<template>
  <div class="resources__entry" id="resources__entry">
    <img class="home__entry--background" src="../../assets/resources-entry.jpg" alt="Notaire outremont">
    <div class="resources__entry--content">
      <h1 class="resources__entry--content--title">{{ $t("resourcesTranslate.resourcesEntryTitle") }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'resources-entry',
  data() {
    return {
      locale: 'fr'
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  }
}
</script>
